import * as React from 'react';
import { observer } from 'mobx-react';
import { Grid } from 'telia-front-react';
import Field from '../field/Field';
function Fieldset(props) {
    const cssClass = props.cssClass ? props.cssClass : 'grid--center-xs';
    return (React.createElement(Grid, { className: `${cssClass} nls_protected` }, props.fields.map((field) => (React.createElement(Field, { key: field.id, field: field, callback: props.callback })))));
}
export default observer(Fieldset);
//# sourceMappingURL=Fieldset.js.map